import isToday from 'date-fns/isToday'

export function isTodayText(start_time) {
  return isToday(Date.parse(`${start_time}Z`))
    ? `TODAY'S APPOINTMENT`
    : `NEXT APPOINTMENT`
}
